import Label from '@components/label'
import { BENEFITS_CAPTIONS } from '@lib/constants'

type BenefitsLabelsProps = {
  benefits: (keyof typeof BENEFITS_CAPTIONS)[]
}

export default function BenefitsLabels({ benefits }: BenefitsLabelsProps): JSX.Element {
  return (
    <Label.Group>
      {benefits.map(
        (benefit, index): JSX.Element => (
          <Label key={index}>{BENEFITS_CAPTIONS[benefit]}</Label>
        ),
      )}
    </Label.Group>
  )
}
